export * from './icon.component';
export * from './icon.module';
